import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldWarning, X } from "@phosphor-icons/react";

const DISMISS_KEY = "h57.phishing_banner_dismissed";

/**
 * Persistent anti-phishing warning shown at the top of the messages inbox
 * and inside every conversation. Users can dismiss for the current session
 * only — it comes back on the next visit so the reminder stays fresh.
 */
export default function PhishingWarningBanner({ testId = "phishing-warning-banner" }) {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, "1");
    } catch { /* silent */ }
    setDismissed(true);
  };

  return (
    <div
      data-testid={testId}
      className="mb-4 flex items-start gap-3 border border-[#FFD700]/40 bg-[#FFD700]/5 px-3 py-2.5"
    >
      <ShieldWarning size={18} weight="fill" className="shrink-0 mt-0.5 text-[#FFD700]" />
      <div className="flex-1 text-[11px] leading-relaxed text-zinc-200">
        <span className="font-mono uppercase tracking-widest text-[10px] font-bold text-[#FFD700]">Watch out for scams</span>
        <span className="text-zinc-300">
          {" "}— Hunt57 will <strong className="text-white">never</strong> ask you to &ldquo;verify your account,&rdquo;
          reset your password, or claim a prize via a DM link. The only official domain is{" "}
          <span className="font-mono text-white">hunt57.com</span>. Anything else is a phishing attempt — hover any
          message and click the flag icon to report. Read the full guide:{" "}
          <Link to="/trust-safety#phishing" className="underline hover:text-[#FFD700]" data-testid="phishing-banner-learn-more">
            Trust &amp; Safety →
          </Link>
        </span>
      </div>
      <button
        type="button"
        onClick={dismiss}
        data-testid={`${testId}-dismiss`}
        aria-label="Dismiss warning"
        className="shrink-0 text-zinc-500 hover:text-white p-0.5"
      >
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
